import { render, staticRenderFns } from "./RecordPanel.vue?vue&type=template&id=ca582072&scoped=true&"
import script from "./RecordPanel.vue?vue&type=script&lang=js&"
export * from "./RecordPanel.vue?vue&type=script&lang=js&"
import style0 from "./RecordPanel.vue?vue&type=style&index=0&id=ca582072&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca582072",
  null
  
)

export default component.exports